export default {
  namespaced: true,
  state: {
    cateList: [],
    // 市场购当前选中type()
    type: '',
    // 市场购当前选中下标
    marketIndex: 0
  },
  getters: {},
  mutations: {
    UPDATE_LIST: (state: any, list: any) => {
      state.cateList = list
    },
    UPDATE_TYPE: (state: any, val: any) => {
      state.type = val
    },
    UPDATE_INDEX: (state: any, val: any) => {
      state.marketIndex = val
    }
  },
  actions: {}
}
